import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import CenterTop from "@/components/layout/CenterTop.vue";
import Banner from "@/components/banner/Banner.vue";
import axios from "axios";
import { router } from "@/router";
var UnifiedStatistics = /*#__PURE__*/function (_Vue) {
  function UnifiedStatistics() {
    var _this;
    _classCallCheck(this, UnifiedStatistics);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UnifiedStatistics, [].concat(args));
    _defineProperty(_this, "internalMetabaseDashboardEmbedUrl", '');
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(UnifiedStatistics, _Vue);
  return _createClass(UnifiedStatistics, [{
    key: "mounted",
    value: function mounted() {
      if (!this.isUnifiedStatisticsEnabled) {
        router.push({
          name: 'HomePage'
        });
      }
      this.requestMetabaseEmbedUrl();
    }
  }, {
    key: "isUnifiedStatisticsEnabled",
    get: function get() {
      return store.getters.isUnifiedStatisticsEnabled;
    }
  }, {
    key: "metabaseDashboardEmbedUrl",
    get: function get() {
      return this.internalMetabaseDashboardEmbedUrl;
    },
    set: function set(newUrl) {
      if (newUrl !== this.internalMetabaseDashboardEmbedUrl) {
        this.internalMetabaseDashboardEmbedUrl = newUrl;
      }
    }
  }, {
    key: "requestMetabaseEmbedUrl",
    value: function requestMetabaseEmbedUrl() {
      var _this2 = this;
      axios({
        url: "".concat(store.getters.STATISTICS_API_URL, "/metabase-embed-url"),
        method: 'POST'
      }).then(function (response) {
        _this2.errorMsg = '';
        _this2.metabaseDashboardEmbedUrl = response.data;
      }).catch(function (err) {
        _this2.errorMsg = (err === null || err === void 0 ? void 0 : err.data) || err;
      });
    }
  }]);
}(Vue);
UnifiedStatistics = __decorate([Options({
  components: {
    Banner: Banner,
    CenterTop: CenterTop
  }
})], UnifiedStatistics);
export default UnifiedStatistics;